import React, { forwardRef } from 'react';
import { SnackbarContent } from 'notistack';
import Alert from '@mui/material/Alert';
import { string } from 'prop-types';
import { oneOf } from 'prop-types';

const SnackbarAlert = forwardRef((props, ref) => {
  const { message, variant } = props;
  return (
    <SnackbarContent ref={ref} role="alert">
      <Alert severity={variant} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </SnackbarContent>
  );
});

SnackbarAlert.propTypes = {
  message: string,
  variant: oneOf(['success', 'error', 'warning', 'info'])
};

export default SnackbarAlert;
